// extracted by mini-css-extract-plugin
module.exports = {"pinTopItem":"styles_pinTopItem__D2mo_","pinBottomItem":"styles_pinBottomItem__N4P0M"};